









import { defineComponent } from '@vue/composition-api';
import AudioPlayerProgressBar from './AudioPlayerProgressBar.vue';

export default defineComponent({
  name: 'CompactAudioPlayer',
  props: {
    currentTime: { type: Number, default: 0 },
    duration: { type: Number, default: 0 },
    isPlaying: { type: Boolean, default: false },
    title: String,
    artist: String,
  },
  components: {
    AudioPlayerProgressBar,
  },
  setup(_, ctx) {
    return {
      togglePlay() {
        ctx.emit('audio-player:toggle-play');
      },
      seeked(val) {
        ctx.emit('audio-player:set-current-time', val);
      },
    };
  },
});
